import { config as base } from './base';
import { config as AT } from './AT';
import { config as HU } from './HU';

export const featureConfigMap = {
    base,
    AT,
    HU,
};
